import React from "react";
import { EmptyLabel } from "../../../label/EmptyLabel.js";
import "../../../label/LabelHoc.js";
import { AutoAdjustedWidthTooltip } from "../../../tooltip/AutoAdjustedWidthTooltip.js";
import "@mui/material";
import "../../../tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../../tooltip/Tooltip.js";
import "../../../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
const renderCellWithTooltip = (params, showEmptyCharacter = true, emptyCharacter = "dash") => {
  const colDef = params.colDef;
  const value = colDef.valueFormatter ? params.formattedValue : params.value;
  return renderValueWithTooltip(value, showEmptyCharacter, emptyCharacter);
};
const renderValueWithTooltip = (value, showEmptyCharacter = true, emptyCharacter = "dash") => {
  const isEmpty = value === null || value === void 0;
  return isEmpty ? /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: showEmptyCharacter ? emptyCharacter : "none" }) : /* @__PURE__ */ React.createElement(AutoAdjustedWidthTooltip, { value, showEmptyCharacter });
};
export {
  renderCellWithTooltip,
  renderValueWithTooltip
};
//# sourceMappingURL=GridCellWithTooltip.js.map
